import fallbackImage from './fallback-image.png';
import risenHopeLogo from './risenhope-logo.png';
import dot from './dot.png';

export const images = {
  fallbackImage,
  risenHopeLogo,
  dot,
};
